import { IEvent } from "../models/Event";

// "#78b22d" -> "120, 178, 45", so the styles can build translucent tints with rgba(var(--x), alpha).
// The browser does the parsing, so any css color works (hex, rgb(), named colors...)
const toRgbTriplet = (color: string): string | null => {
    if (!color) return null
    const probe = document.createElement('span')
    probe.style.color = color
    if (!probe.style.color) return null

    document.body.appendChild(probe)
    const [red, green, blue] = getComputedStyle(probe).color.match(/[\d.]+/g) || []
    probe.remove()
    return blue === undefined ? null : `${red}, ${green}, ${blue}`
}

export const applyEventTheme = (event: IEvent) => {
    const rootStyle = document.documentElement.style
    const setVariable = (name: string, value: string | null) => {
        if (value) rootStyle.setProperty(name, value)
    }

    setVariable('--backgroundColorJson', event.backgroundColor)
    setVariable('--backgroundColorRgb', toRgbTriplet(event.backgroundColor))
    setVariable('--fontColorJson', event.foregroundColor)
    setVariable('--coverImage', event.coverImage && `url(${JSON.stringify(event.coverImage)})`)

    if (event.backgroundColor) {
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', event.backgroundColor)
    }
}
